import { Component, inject } from '@angular/core';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { Themes } from 'themes';
import { ContactComponent } from 'app/shared/components/contact/contact.component';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';
import { BannerComponent } from 'app/shared/components/banner/banner.component';

@Component({
  selector: 'ez-completed',
  imports: [MainLayoutComponent, ContactComponent, BannerComponent],
  templateUrl: './completed.component.html',
  styleUrl: './completed.component.scss',
})
export class CompletedComponent {
  protected readonly Themes = Themes;
  readonly landingpageConfig = inject(LandingpageConfigurationStateService).landingpageConfiguration;
}
